import { Component, OnInit } from '@angular/core';
import {HssResponse} from '../../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../../services/rest-api/HssErrorResponse';
import {InfoApiService} from '../../../../services/rest-api/info.api.service';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {StorageService} from '../../../../services/rest-api/storage.service';
import {SeoService} from '../../../../services/seo/seo.service';

@Component({
  selector: 'app-allstaff',
  templateUrl: './allstaff.component.html',
  styleUrls: ['./allstaff.component.scss']
})
export class AllstaffComponent implements OnInit {

  staffData: any[] = [];
  selectedCat: any;
  category: string = '';
  loader: boolean = false;
  divRepat: any[] = [1,2,3,4,5,6];
  deanData: any[] = [];
  private catId: number = 0;

  constructor(
    private _info: InfoApiService,
    private _actRoute: ActivatedRoute,
    private storage: StorageService,
    private seo: SeoService
  ) {
  }

  ngOnInit(): void {
    this._actRoute.paramMap.subscribe(params => {
      this.selectedCat = String(this._actRoute.snapshot.paramMap.get('catid'));
      this.getStaffByCat(this.selectedCat);
      this.category = String(this._actRoute.snapshot.paramMap.get('category'));
    });

    this.getDeanDetails();
    this.seo.setMeta('Staff members of the departments');
  }

  // View staff by category id
  getStaffByCat(catId: number){
    this.loader = true;
    this._info.getStaffByCat(catId).subscribe (
      (response: HssResponse<any>) => {
        this.staffData = response.body;
        this.loader = false;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get dean details
  getDeanDetails(){
    // Get dean staff id
    const localfacultyData = this.storage.getData('facultyData');
    const faculty = localfacultyData ? JSON.parse(localfacultyData): [];

    this.loader = true;
    this._info.getStaffMember(faculty[0].dean_staff_id).subscribe (
      (response: HssResponse<any>) => {
        this.deanData = response.body;

        this.loader = false;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  getSpeciality(specialities: []){
    const result:any[] = specialities.filter((item:any)=> item.specialty_type_id===2);
    return (result.length > 0 && result[0].description) ? result[0].description : "";
  }
}
